import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "font-gordita-medium text-[16px] text-Text/text_high leading-[18px] top-[19px] absolute" }, "Build Duration", -1)

import { IncrediCard, IncrediChartLine } from 'incredi-ui';
import { computed } from 'vue';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { dataZoomSliderOff } from '@/views/dashboard/dashboard.charts.utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'build-duration-chart',
  props: {
    chartOptions: null
  },
  setup(__props: any) {

const props = __props as {
  chartOptions: InstanceType<typeof IncrediChartLine>['$props'];
}


const chartProps = computed(() => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { options, ...rest } = props.chartOptions;
  return rest;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createVNode(_unref(IncrediCard), { class: "relative h-full p-[16px] !shadow-none border border-Border/border_natural" }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_unref(IncrediChartLine), _mergeProps({
            options: {
          dataZoom: _unref(dataZoomSliderOff),
          ...(__props.chartOptions.options || {}),
        },
            height: "284px"
          }, _unref(chartProps)), null, 16, ["options"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})